import React from "react";
import { Container, Typography, Box, useTheme } from "@mui/material";

const createData = (areaCode, emirates, location, term1, term2, term3, total) => {
  return { areaCode, emirates, location, term1, term2, term3, total };
};

const rows = [
  createData(
    1,
    "DUBAI",
    "Gardens, Discovery Gardens, Al Furjan, Al Wasel Gardenia",
    " ",
    " ",
    " ",
    " "
  ),
  createData(
    2,
    "DUBAI",
    "JLT, Marina, JBR, Springs, Barsha, Tecom, Greens, Meadows, Jebel Ali power plant, Jumeirah Village Park, JVT",
    " ",
    " ",
    " ",
    " "
  ),
  createData(
    3,
    "DUBAI",
    "Jumeirah village circle, Sports city, Motor city, DIP, Arabian Ranches -1, Green Community, IMPZ",
    " ",
    " ",
    " ",
    " "
  ),
  createData(
    4,
    "DUBAI",
    "Deira, Burdubai, Jumeirah-1, Ghusais, Satwa, I'ntl city, Sheikh Zayed Rd, Downtown, Al Khail Gate, Al Khail Heights, Dubai Hills, Al Quoz, Dubai Silicon Oasis, Sky Court, Q Point, Liwan, Mudon, Karama, Al wasel, Jaffiliya, Diyaffa, Dry docs, Um-Sequim, Remram, Damac Hills - 1",
    " ",
    " ",
    " ",
    " "
  ),
  createData(
    5,
    "SHARJAH",
    "Sharjah Al Nahda, Abu Shagara, Rolla, King Faizal St, Al Wahda St Subway – 1,2,3 ",
    " ",
    " ",
    " ",
    " "
  ),
];

const Table1 = () => {
  const theme = useTheme();

  const cellStyle = {
    border: "1px solid black",
    padding: theme.spacing(1),
    fontSize: { xs: "0.7rem", sm: "0.8rem", md: "1rem" },
  };

  const headerCellStyle = {
    ...cellStyle,
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
  };

  return (
    <Container maxWidth="xl" disableGutters>
      <Box
        sx={{
          textAlign: "center",
          pt: 4,
          px: { xs: 2, sm: 4, md: 6, lg: 8 },
        }}
      >
        <Typography
          variant="h4"
          component="h4"
          sx={{
            textTransform: "uppercase",
            color: "black",
            mb: 4,
            fontSize: { xs: "1rem", md: "1.4rem", xl: "1.8rem" },
            borderBottom: "2px solid",
            borderColor: "black",
            pb: 1,
          }}
        >
          TRANSPORT FEES FOR THE ACADEMIC YEAR 2024
        </Typography>

        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <table style={{ minWidth: "650px", width: "100%" }}>
            {/* <thead>
              <tr>
                <th rowSpan={2} colSpan={3} style={headerCellStyle}>DPS – JEBEL ALI</th>
                <th colSpan={3} style={headerCellStyle}>TERM FEES **</th>
                <th rowSpan={3} style={headerCellStyle}>TOTAL</th>
              </tr>
              <tr>
                <th colSpan={3} style={headerCellStyle}>(AED)</th>
              </tr>
              <tr>
                <th style={headerCellStyle}>Area Code</th>
                <th style={headerCellStyle}>Emirates</th>
                <th style={headerCellStyle}>Location</th>
                <th style={headerCellStyle}>Term 1</th>
                <th style={headerCellStyle}>Term 2</th>
                <th style={headerCellStyle}>Term 3</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td style={cellStyle}>{row.areaCode}</td>
                  <td style={cellStyle}>{row.emirates}</td>
                  <td style={cellStyle}>{row.location}</td>
                  <td style={cellStyle}>{row.term1}</td>
                  <td style={cellStyle}>{row.term2}</td>
                  <td style={cellStyle}>{row.term3}</td>
                  <td style={cellStyle}>{row.total}</td>
                </tr>
              ))}
            </tbody> */}
            <tfoot>
              <tr>
                <td colSpan={4} style={headerCellStyle}>
                  PAYMENT DUE DATES FOR REGULAR STUDENTS
                </td>
                <td style={headerCellStyle}>15th Mar</td>
                <td style={headerCellStyle}>15th Aug</td>
                <td style={headerCellStyle}>15th Nov</td>
              </tr>
              <tr>
                <td colSpan={4} style={headerCellStyle}>
                  LAST DATE OF PAYMENT
                </td>
                <td style={headerCellStyle}>25th Mar</td>
                <td style={headerCellStyle}>25th Aug</td>
                <td style={headerCellStyle}>25th Nov</td>
              </tr>
              <tr>
                <td colSpan={4} style={headerCellStyle}>
                  PAYMENT DUE DATES FOR NEW ADMISSIONS
                </td>
                <td colSpan={3} style={headerCellStyle}>
                  IMMEDIATELY UPON ADMISSION
                </td>
              </tr>
            </tfoot>
          </table>
        </Box>

        <Typography
          mt={5}
          variant="body1"
          component="p"
          sx={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: { xs: "0.75rem", md: "1rem", xl: "1.5rem" },
            fontStyle: "italic",
          }}
        >
          ** The above fees are for the current academic year and subject to change and the
          difference will be collected, once approved by the concerned authority.
        </Typography>
        <Typography
          mt={3}
          variant="body1"
          component="p"
          sx={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: { xs: "0.75rem", md: "1rem", xl: "1.5rem" },
          }}
        >
          Note: Student will not be allowed to board the bus in case payment is not received before
          last date of payment (as mentioned above)
        </Typography>

        <Typography
          mt={3}
          variant="body1"
          component="p"
          sx={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: { xs: "0.75rem", md: "1rem", xl: "1.5rem" },
            fontStyle: "italic",
            textTransform: "uppercase",
          }}
        >
          VAT OR ANY OTHER TAXES IF APPLICABLE ON TRANSPORT FEE SHALL BE CHARGED ADDITIONALLY ON
          ABOVE AMOUNTS.
        </Typography>
      </Box>
    </Container>
  );
};

export default Table1;
